import { getContext } from '@fiverr-private/fiverr_context';
import { getPageName } from './getPageName';
import type { BI_EVENTS, BI_OPTIONS } from './constants';

export type ConnectToAiBiEvent = (typeof BI_EVENTS)[keyof typeof BI_EVENTS];
export type ConnectToAiBiOption = (typeof BI_OPTIONS)[keyof typeof BI_OPTIONS];

export interface ConnectToAiBiParams {
    type: ConnectToAiBiEvent;
    action: 'impression' | 'click';
    option?: ConnectToAiBiOption;
    isTouch: boolean;
}

/** Builds the user_actions event from the MCP BI spec. The caller sends it with its own BI sender. */
export const buildConnectToAiEvent = ({ type, action, option, isTouch }: ConnectToAiBiParams) => {
    const { userId, pageCtxId } = getContext();

    return {
        type,
        group: 'user_actions',
        sub_group: 'website_actions',
        platform: isTouch ? 'mobile_web' : 'web',
        action: { type: action },
        feature: { name: 'connect_to_your_ai' },
        page: {
            ctx_id: pageCtxId,
            name: getPageName(),
            ...(option ? { element: { text: option } } : {}),
        },
        ...(userId ? { user: { id: userId } } : {}),
    };
};
